import { observer } from 'mobx-react-lite';
import React, { useCallback, useEffect, useState } from 'react';
import { reportEvent } from 'utils/analytics';
import { ISearch } from 'utils/networkRequests';
import { useUserTermUrlParam } from 'utils/query';

import OfferingSearchInput from './OfferingSearchInput';

interface ISearchProps {
  minimal?: boolean;
  defaultSearchTerm?: string;
  onSearch?: (search?: ISearch) => void;
}

const UserSearch = ({ minimal, defaultSearchTerm, onSearch }: ISearchProps) => {
  const [searchTerm, setSearchTerm] = useState<string>('');

  useEffect(() => {
    setSearchTerm(defaultSearchTerm || '');
  }, [defaultSearchTerm]);

  useUserTermUrlParam(
    useCallback((query) => {
      if (query) {
        setSearchTerm(query);
      }
    }, [])
  );

  const onSubmitSearch = (searchTerm?: string, searchType?: string) => {
    reportEvent('user_search', { search_term: searchTerm || '', search_type: searchType });

    setSearchTerm(searchTerm || '');
    onSearch && onSearch({ userSearchTerm: searchTerm });
  };

  const clearSearch = () => {
    onSubmitSearch('');
  };

  const onKeyDown = (event: React.KeyboardEvent<HTMLInputElement>) => {
    if (event.key === 'Enter') {
      onSubmitSearch(searchTerm);
    } else if (event.key == 'Escape') {
      onSubmitSearch('');
    }
  };

  return (
    <OfferingSearchInput
      cancelButton
      onCancelClick={clearSearch}
      searchTerm={searchTerm}
      placeholder={minimal ? '' : 'Email, Name'}
      onChange={setSearchTerm}
      onSubmit={onSubmitSearch}
      onKeyDown={onKeyDown}
    />
  );
};

export default observer(UserSearch);
